import PubSub from "underpub-js";

var FloorplanCard = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-FloorplanCard',
	};

	$.extend(true, this.options, options);

};

FloorplanCard.prototype.init = function() {

	var self = this;

};

export default FloorplanCard;
